export const GET_TICKETS = 'get_tickets';
